import React, { Component } from 'react'
import Header from './Header'
import './Antiquity.css'

class Antiquity extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyAntiquity">
                    <p className="textAntiquity">A venir...</p>
                </div>
            </div>
        )
    }
}

export default Antiquity